var _desc, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "15px",
    viewBox: "0 0 22 15",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.502 0.125389C19.8207 0.199078 20.4684 0.392519 21.0649 1.44545C21.6864 2.49686 22 4.30769 22 7.49732L22 7.50825C22 10.6827 21.6864 12.5073 21.0663 13.5478C20.4697 14.6005 19.822 14.7914 18.5034 14.88C17.1848 14.955 13.8725 15 11.0027 15C8.1276 15 4.81381 14.955 3.49657 14.8786C2.18066 14.7901 1.53327 14.5991 0.930781 13.5463C0.316294 12.5059 0 10.6814 0 7.50685L0 7.496C0 4.30769 0.316294 2.49686 0.930781 1.44545C1.53327 0.391267 2.18228 0.199078 3.4979 0.124067C4.81381 0.03674 8.1276 0 11.0027 0C13.8725 0 17.1848 0.03674 18.502 0.125389ZM8.7998 3.5293L8.7998 11.4705L15.8398 7.49985L8.7998 3.5293Z",
    id: "YT",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoYoutube);
export default __webpack_public_path__ + "static/media/ico-youtube.cdb5daf3f57d69a306ca1874e3e493cc.svg";
export { ForwardRef as ReactComponent };